{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "olenka/inner-box",
	"version": "1.0.0",
	"title": "Inner Box",
	"category": "olenka-general",
	"icon": "index-card",
	"description": "A single feature card with a heading and description",
	"parent": ["olenka/text-with-boxes-wrapper"],
	"supports": {
		"html": false
	},
	"attributes": {
		"heading": {
			"type": "string",
			"default": "Block theme architecture"
		},
		"description": {
			"type": "string",
			"default": "Built for the modern WordPress site editor, with a structure that supports templates, template parts, patterns, and global styles."
		},
		"backgroundColor": {
			"type": "string",
			"default": ""
		},
		"headingColor": {
			"type": "string",
			"default": ""
		},
		"preHeadingColor": {
			"type": "string",
			"default": ""
		},
		"descriptionColor": {
			"type": "string",
			"default": ""
		}
	},
	"textdomain": "olenka"
}
